import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API

let token = localStorage.getItem('token')
if(token){
    store.commit('changeToken', token)
    try{
        await store.dispatch('loadRole')
    }catch (e){
        localStorage.removeItem('token')
        window.location.reload();
    }
}

createApp(App).use(store).use(router).mount('#app')